import { getProduto } from 'config/produto-env';

// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24; // 1 day
export const TOKEN_COOKIE = 'bb.token';
export const REFRESH_TOKEN_COOKIE = 'bb.refreshToken';
export const BADGES_STORAGE_KEY = 'bb.badges';
export const VERSION = 'v3.0.020';

/**
 * Collection das iniciativas da pré-inscrição (cadastro, edição, aprovação e exclusão).
 * 2027: `bb_task_pre__c`, separada de `bb_task__c`, que guarda a base clonada de 2026.
 * Os aggregates `entregas`, `entregas_pre_inscricao`, `tasks_manager` e `tasks_by_prefixo` leem a mesma collection.
 */
export const COLECAO_INICIATIVAS = 'bb_task_pre__c';

/**
 * ControlDate IDs for phase management.
 * These match the _id field from the controle_datas__c collection.
 *
 * PHASE_IDS_BASE — IDs comuns aos dois produtos.
 * PHASE_IDS_PREMIO_BB_EXTRAS — exclusivos do Prêmio BB.
 * PHASE_IDS_ELBB_EXTRAS — exclusivos do Prêmio ELBB.
 * PHASE_IDS — manutenção de compatibilidade; equivale ao build Prêmio BB.
 *             config/produto.ts importa as partes e monta o conjunto do produto.
 */
export const PHASE_IDS_BASE = {
  // ELBB phases (comuns)
  ELBB_PRE_REGISTRATION: 'etapa_pre_elbb',
  ELBB_REGISTRATION_PERIOD: 'periodo_cadastro_elbb',
  ELBB_CONFIRMATION: 'confirmacao_inscricao_elbb',
  ELBB_INSCRIPTION: 'etapa_inscricao_elbb',
  // Conexao phases (comuns)
  CONEXAO_PRE_REGISTRATION: 'etapa_pre_conexao',
  CONEXAO_REGISTRATION_PERIOD: 'periodo_cadastro_conexao',
  CONEXAO_MANAGER_APPROVAL: 'aprovacao_gestor_conexao',
  CONEXAO_CONFIRMATION: 'confirmacao_inscricao_conexao',
  ETAPA_3_PREMIO: 'etapa_tres_premio',
} as const;

/** Extras exclusivos do Prêmio BB */
export const PHASE_IDS_PREMIO_BB_EXTRAS = {
  ETAPA_1_PREMIO: 'etapa_um_premio',
  ETAPA_2_PREMIO: 'etapa_dois_premio',
} as const;

/**
 * Extras exclusivos do Prêmio ELBB.
 * ETAPA_2_PREMIO aqui aponta para o _id real do controle_datas__c do tenant ELBB.
 */
export const PHASE_IDS_ELBB_EXTRAS = {
  ELBB_VOTING_STAGE1: '69d952080af3a52b4404f88c',
  ETAPA_2_PREMIO: '69d952660af3a52b4404f962',
} as const;

/** IDs de fase do produto do build (REACT_APP_PRODUTO): base + extras. */
type PhaseIdsDoProduto = typeof PHASE_IDS_BASE & {
  ETAPA_1_PREMIO?: string;
  ETAPA_2_PREMIO: string;
  ELBB_VOTING_STAGE1?: string;
};

export const PHASE_IDS: PhaseIdsDoProduto =
  getProduto() === 'PREMIO_ELBB'
    ? { ...PHASE_IDS_BASE, ...PHASE_IDS_ELBB_EXTRAS }
    : { ...PHASE_IDS_BASE, ...PHASE_IDS_PREMIO_BB_EXTRAS };

export type PhaseId = typeof PHASE_IDS[keyof typeof PHASE_IDS];